module.exports = __webpack_require__.p + "0c97afecc46068c4a5199f45a99cb807.jpg";